import * as React from 'react';
const SvgGift = (props) => (
  <svg viewBox="0 0 120 125" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M40.994 97.024c3.915 1.868 9.538 3.6 13.666 5.448a4.015 4.015 0 0 0 1.732.363c7.202-.12 13.883-.697 20.954-1.397a3.927 3.927 0 0 0 3.54-3.672c.006-.074.009-.148.014-.222.277-4.606-3.203-8.523-7.8-8.929-3.497-.309-6.745-.846-9.971-1.277-.737-.1-1.44-.4-2.017-.872-7.617-6.24-14.189-11.823-22.992-11.803-8.003.017-16.268 3.595-21.983 9.315-1.591 1.591-3.414 2.931-5.5 3.771C7.74 88.918 4.63 90.335 2 91.19"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M86.52 88.484c5.16-1.82 10.6-3.92 16.36-6.6 4.92-2.28 10.78-.9 14.16 3.34l.08.1c1.48 1.84 1.04 4.52-.92 5.82-19.06 12.54-47.22 31.38-56.4 31.38s-25.06-4.26-37.74-6.68c-.88-.16-1.8-.04-2.58.4-3.66 1.96-7.98 4.64-11.48 6.42M80.655 4.168l9.863 16.652a3.082 3.082 0 0 0 1.997 1.434l19.066 4.126c2.297.497 3.203 3.254 1.64 4.994l-12.972 14.42a3.014 3.014 0 0 0-.763 2.32l1.923 19.204c.232 2.314-2.143 4.017-4.297 3.085l-17.877-7.74a3.115 3.115 0 0 0-2.469 0l-17.877 7.74c-2.154.932-4.529-.771-4.297-3.085l1.923-19.203a3.01 3.01 0 0 0-.763-2.32L42.78 31.375c-1.563-1.738-.657-4.495 1.64-4.995l19.066-4.126a3.082 3.082 0 0 0 1.997-1.434l9.863-16.652c1.189-2.005 4.123-2.005 5.309 0Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgGift;
